import React from 'react';
import styled from 'styled-components';
import { Flex, Box } from '@rebass/grid';
import { IconChatRound } from '@amtrav/icons';
import { getThemeProp } from '@amtrav/themes';
import { getTokenValue, THEME_TOKENS, ZINDEX } from '@amtrav/theme-system';

const ColoredSphere = styled(Flex)`
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  background-color: ${getThemeProp('chat.minimized-chat--color')};
  border-radius: 50px;
  box-shadow: ${getTokenValue(THEME_TOKENS.base.shadow.raised)};
  cursor: pointer;
`;

const GraphicWrapper = styled(Box)`
  font-size: 30px;
  color: ${getThemeProp('chat.minimized-icon--color')};
  margin-top: 6px;
  margin-left: -2px;
`;

export const ChatSystemLocationMini = styled(Box)`
  position: fixed;
  z-index: ${ZINDEX.MODAL};
  bottom: 15px;
  right: 15px;
`;

const WebChatMinimized = () => {
    return (
        <ColoredSphere>
            <GraphicWrapper>
                <IconChatRound />
            </GraphicWrapper>
        </ColoredSphere>
    );
};
export const OpenButton = ({ onClick }: { onClick: () => void }) => {
    return (
        <ChatSystemLocationMini onClick={onClick}>
            <WebChatMinimized />
        </ChatSystemLocationMini>
    );
};

